import React, { useEffect } from 'react';
import SummaryTable, { SummaryTableRow } from '@appComponents/SummaryTable/SummaryTable';
import IPurchaseSummary from './IPurchaseSummary';
import CurrencyElement from '@appComponents/CurrencyElement/CurrencyElement';
import Big from 'big.js';
import * as style from './PurchaseSummaryStyle.module.scss'
import ToolTip from '@appComponents/ToolTip/ToolTip';
import { dropdownSelectRef } from '@appComponents/Dropdown/Dropdown';

const PurchaseSummary: React.FunctionComponent<IPurchaseSummary> = (props) => {
  useEffect(() => {
    if (dropdownSelectRef && dropdownSelectRef.current) {
      dropdownSelectRef.current.disabled = true;
    }
    return () => {
      if (dropdownSelectRef && dropdownSelectRef.current) {
        dropdownSelectRef.current.disabled = false;
      }
    };
  }, []);

  const displayRow = (key: number, label: string, value: number | string, highlighted: boolean = false) => {
    const className = highlighted ? style.highlighted : undefined;
    return label && value && (
      <SummaryTableRow key={key} label={label} value={formatValue(label, value)} className={className}/>
    );
  };

  const formatValue = (label: string, value: string | number) => {
    switch (label) {
      case 'Amount to purchase':
        return (
          <CurrencyElement
            value={value}
            currency={props.currency}
          />
        );
      case 'Transaction Fee':
      case 'Total to pay':
        return typeof(value) === 'string'
          ? value
          : (
            <CurrencyElement
              value={value}
              currency={props.currencyToPay}
            />
          );
      case 'Exchange Rate':
        const roundedValue = Big(value).round(8, 0);
        return (
          <>
            <CurrencyElement
              value={1}
              currency={props.currency}
            />
            ~
            <CurrencyElement
              value={value}
              currency={props.currencyToPay}
            />
            <ToolTip
              maxWidth={300}
              text={<>{roundedValue.toString()} <span className={style.currency}>{props.currencyToPay}</span></>}
            >
              &nbsp; &#9432;
            </ToolTip>
          </>
        );
      case 'Your balance after purchase':
        return (
          <CurrencyElement
            value={Number(Big(props.purchaseWallet.balance).add(value))}
            currency={props.currency}
          />
        );
      default:
        return value;
    }
  };

  return (
    <SummaryTable>
      {displayRow(0, 'Amount to purchase', props.amount)}
      {displayRow(0.1, 'Transaction Fee', props.purchaseFees.purchaseFee)}
      {displayRow(0.2, 'Total to pay', props.purchaseFees.totalToPay)}
      {displayRow(0.3, 'Exchange Rate', props.purchaseFees.priceFor1Token)}
      {displayRow(0.4, 'Your balance after purchase', props.amount)}
    </SummaryTable>
  );
};

export default PurchaseSummary;
